<template>
  <v-row class="py-0">
    <v-col cols="12">
      <h3 class="title dw_green--text font-weight-light">
        <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiArchive" />
        Remove Content
      </h3>
      <v-tabs
        v-model="tab"
        background-color="bg_dark"
        color="dw_green"
        dark
        icons-and-text
        class="mt-2"
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          Tools
          <v-icon v-text="mdiPaletteSwatchOutline" />
        </v-tab>
        <v-tab href="#tab-2">
          Tags
          <v-icon v-text="mdiPoundBox" />
        </v-tab>
        <v-tab href="#tab-3">
          Objectives
          <v-icon v-text="mdiCompassOutline" />
        </v-tab>
        <v-tab href="#tab-4">
          Plays
          <v-icon v-text="mdiCrownOutline" />
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item :value="'tab-1'">
          <v-card flat color="bg_dark">
            <archive-tools />
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-2'">
          <v-card flat color="bg_dark">
            <archive-tags />
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-3'">
          <v-card flat color="bg_dark">
            <archive-objectives />
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-4'">
          <v-card flat color="bg_dark">
            <archive-plays />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import {
  mdiArchive,
  mdiCrownOutline,
  mdiPaletteSwatchOutline,
  mdiPoundBox,
  mdiCompassOutline
} from '@mdi/js';
import archiveTools from '@/components/forms/archiveContent/archiveTools.vue';
import archiveTags from '@/components/forms/archiveContent/archiveTags.vue';
import archiveObjectives from '@/components/forms/archiveContent/archiveObjectives.vue';
import archivePlays from '@/components/forms/archiveContent/archivePlays.vue';

export default {
  name: 'adminReview',
  components: {
    archiveTools,
    archiveTags,
    archiveObjectives,
    archivePlays
  },
  inject: ['permissions'],
  data() {
    return {
      mdiArchive,
      mdiCrownOutline,
      mdiPaletteSwatchOutline,
      mdiPoundBox,
      mdiCompassOutline,
      tab: 'tab-4'
    };
  }
};
</script>
